// extracted by mini-css-extract-plugin
export default {"notice":"VoucherWallet_notice__+rAGA","content":"VoucherWallet_content__r5fU3","iframe":"VoucherWallet_iframe__WlK-n","container":"VoucherWallet_container__62WXp"};